/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.ClientPoint {
    "use strict";

    export class ClientPointContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        public clientDisplayName: string = '';

        constructor(
            public appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            timeoutService: angular.ITimeoutService,
            customDataContextConfig: Meevo.Model.ICustomDataContextConfig,
            protected clientPointService: Meevo.Plugins.ClientPoint.IClientPointService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $q: ng.IQService,
            protected $rootScope: angular.IRootScopeService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, customDataContextConfig, false);

            this.baseEndpoint = appSettings.API_ENDPOINTS.clientPoint;
            this.sectionTemplatePath = "app/plugins/clientPoint/sectionViews/";

            this.buildCrudSecurityKeys(this.securityKeys.MANAGEMENT_CLIENTPOINT);
            this.entityType = 'clientPoint';

            this.mode = Meevo.Model.MaintenanceFormState.Readonly;

            this.initializeSections();
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_CLIENTPOINT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(this, 0, "SECTION_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.clientPoint, "",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.ClientPointManagerMain, this.clientPointService, this.busyService, this.modalService, this.$rootScope,
                    this.securityKeys.MANAGEMENT_CLIENTPOINT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ, this.trackingService, this.$q));
            }

           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_CLIENTPOINT_TAB_HISTORY + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new HistorySection(1, "SECTION_HISTORY", "history.html", false, false, this.appSettings.API_ENDPOINTS.clientPoint, "history",
                    this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.ClientPointManagerHistory, this.clientPointService, this.modalService,
                    this.busyService, this.$q, this.$rootScope, this, this.securityKeys.MANAGEMENT_CLIENTPOINT_TAB_HISTORY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        protected buildCrudSecurityKeysBase(baseKey, hasCreateKey = false, hasCopyKey = false) {
            this.editSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;
            this.deleteSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_DELETE;
            this.addSecurityKey = baseKey + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE;
            this.copySecurityKey = baseKey + ((hasCopyKey) ? Meevo.Components.Common.SecurityParts.KEY_PART_COPY : Meevo.Components.Common.SecurityParts.KEY_PART_WRITE);
        }

        initializeHeader(model: any): void {
            this.clientDisplayName = model.displayName;
            this.headerContent = model.displayName;
        }

        cancel(): void {
            super.cancel();
            this.usageTrackingLog(Meevo.Model.VerbEnum.CancelButtonClicked);
        }

        usageTrackingLog(verbEnum: Meevo.Model.VerbEnum): void {
            let nounValue = this.selectedSection.noun;
            let trackingItem = new Meevo.Model.TrackingItem(nounValue, verbEnum, null, this.itemId);

            this.trackingService.saveTrackingInfo(trackingItem);
        }
        save(): angular.IPromise<any> {
            this.busyService.start();
            this.setMode(Model.MaintenanceFormState.Readonly);
            return (<Meevo.Plugins.ClientPoint.MainSection>this.selectedSection).logPoints().then(() => {
                this.busyService.stop();
            });
            
        }
        selectSection(item, subSectionContentKey?: string): void {
            switch (item.sectionId) {
            case 1: //History
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_CLIENTPOINT_TAB_HISTORY);
                this.editSecurityKey = "";
                break;

            default: //Main
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_CLIENTPOINT_TAB_MAIN, false, true);
                break;
            }
            super.selectSection(item, subSectionContentKey);
        }

        get showCopy(): boolean {
            return false;
        }

        get showDelete(): boolean {
            return false;
        }

        get showEdit():boolean {
            return this.selectedSection.sectionId == 0 && this.isReadonly;
        }
    }
}